import React from 'react';
import ReferAndEarn from '../../Deals/ReferAndEarn';
import RMCard from '../../Deals/RMCard';
import { useProfile } from '../../../context/ProfileContext';
import assetLeasing from '../../../assets/svg/assetLeasing.svg';
import fixedDeposits from '../../../assets/svg/fixedDeposits.svg';
import { useAnalytics } from '../../../hooks/useAnalytics';
import { toast } from 'react-hot-toast';

// Product cards data
const productCards = [
  {
    id: 1,
    title: 'Asset Leasing',
    description: 'Now invest in income-generating assets with predictable monthly payouts',
    banner: 'GET YIELD UPTO 17-18%',
    image: assetLeasing,
    comingSoon: true,
  },
  {
    id: 3,
    title: 'Fixed Deposits',
    description: 'Invest in FDs offered by NBFCs and Banks with the best interest returns.',
    banner: 'UP-TO 8.4% INTEREST RATES',
    image: fixedDeposits,
    comingSoon: true,
  },
];

const ProductCard = ({ product }) => {
  const { track } = useAnalytics();
  return (
    <div className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-100 ">
      {/* Top Section - Image Placeholder */}
      <div className="relative bg-white">
        {/* Banner */}
        {/* <div className="absolute top-4 left-4 bg-green-600 text-white text-xs font-semibold px-3 py-1 rounded-md z-10">
          {product.banner}
        </div> */}

        {/* Image Placeholder */}
        <div className="flex justify-center items-center h-[200px] w-full relative">
          <img src={product.image} alt={product.title} className="w-full h-full object-cover" />
        </div>
      </div>

      {/* Bottom Section - Content */}
      <div className="p-5 bg-white">
        {/* Coming Soon Label */}
        {product.comingSoon && (
          <div
            className="text-green-700 text-[10px] font-semibold mb-[10px]"
            style={{
              letterSpacing: '12%',
            }}
          >
            COMING SOON
          </div>
        )}

        {/* Title */}
        <h3 className="text-xl font-semibold text-stone-800 mb-[10px]">{product.title}</h3>

        {/* Description */}
        <p className="text-sm text-stone-500 mb-3 leading-relaxed">{product.description}</p>

        {/* Call to Action Button */}
        <button
          className="w-full bg-green-700 text-white py-2 mt-5 rounded-lg font-semibold text-base disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer"
          onClick={() => {
            track({
              eventName: `${product.title} - Clicked`,
              eventProperties: {
                product_name: product.title,
                product_id: product.id,
              },
            });

            // Show success message
            toast(
              `${product.title} interest submitted successfully. We will reach-out to you shortly.`,
              {
                duration: 5000,
                position: 'top-center',
              },
            );
          }}
        >
          I'm Interested
        </button>
      </div>
    </div>
  );
};

const OtherProducts = () => {
  const { profileData } = useProfile();

  return (
    <div className="grid xl:grid-cols-3 gap-8 my-6 max-w-7xl mx-auto ">
      <div className="flex xl:col-span-2 flex-col ">
        {/* Product Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 xl:grid-cols-2 gap-6 justify-items-center">
          {productCards.map((product) => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>
      </div>
      <div className="relative flex flex-col gap-2">
        {/* Refer and Earn */}
        {profileData?.features?.enableReferral && <ReferAndEarn />}

        {/* RMCard */}
        {profileData?.clientActions?.enableRMCard && <RMCard />}
      </div>
    </div>
  );
};

export default OtherProducts;
